import React from 'react'
import PropTypes from 'propTypes'
import { cx } from '@emotion/css'
import Container from '../../components/Container'
import styles from './styles'

const Toolbar = ({ className, id, children, testId }) => {
  return (
    <section className={cx(styles.wrapper, className)} id={id} data-testid={testId}>
      <Container className={styles.container}>{children}</Container>
    </section>
  )
}

Toolbar.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  testId: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default Toolbar
